import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';

export type Code = {
  id: number;
  code: string;
  name: string;
  logo?: string;
  ordering?: number;
  status?: string;
};

const getCodes = (): Promise<{ data: Code[] }> => api.get('/codes');

export const useGetCodesQuery = () => {
  return useQuery({
    queryKey: ['codes'],
    queryFn: () => getCodes(),
    select: (data) => {
      return data.data.map((code) => ({
        ...code,
        ordering: code.ordering ?? 99,
      }));
    },
  });
};
